import Link from 'next/link';
import { useCallback, useEffect, useRef, useState } from 'react';
import api from '../../../api/Apis';
import parse from 'html-react-parser';
import dynamic from 'next/dynamic';
import _ from 'lodash';
import HomeComponent from './HomePageStyle';
import Head from 'next/head';
import { useRouter } from 'next/router';
const Slider = dynamic(() => import("react-slick"), { ssr: true });
const HomePageProduct = dynamic(() => import('./HomePageProduct'), { ssr: false });
const ProvenComponent = dynamic(() => import('./provenComponent'), { ssr: false });
const HomePageBelowSection = dynamic(() => import('./HomePageBelowSection'), { ssr: false });
const MailingComponent = dynamic(() => import('@Components/MailingComponent'), {
    ssr: true,
    loading: () => null
});
const ClaimGiftPopup = dynamic(() => import('@Components/ClaimGiftPopup'), {
    ssr: false,
    loading: () => null
});

export const AddCardButtonText = (is_stock_available, costtype, id) => {
    if (is_stock_available) {
        const findData = _.find(costtype, { id: id });
        if (findData?.id === id && findData?.value === "AutoShip") {
            return 'Subscribe';
        }
        return 'Add to Cart'
    } else {
        return "Sold Out"
    }
}

const Home = ({ icon, homePageData, setshowloader, minCartAutoshipCheck, smartShipCheck, setcounts, setInnerLoader, innerLoader, subDomain, USER_DATA, bannerData, ...props }) => {

    const router = useRouter()
    const store = router?.query?.page || "us";
    const { id, name, page } = router.query;
    const isMounted = useRef(true);
    const REFERRAL_CODE = router?.query['referral-code'] ? router?.query['referral-code'] : null;

    const provenRef = useRef();

    const [productData, setProductData] = useState([]);
    const [costtype, setcosttype] = useState([]);
    const [Logintoken, setToken] = useState()
    const [product, setproduct] = useState();
    const [addNotify, setAddNotify] = useState('')
    const [openPopup, setOpenPopup] = useState(false);
    const [quantityCheck, setQuantityCheck] = useState([]);
    const [openClaimGift, setOpenClaimGift] = useState(false);
    const [storeReferral, setStoreReferral] = useState();
    const [currentSlide, setCurrentSlide] = useState(0);
    const [showProven, setShowProven] = useState(false);
    const [domainData, setDomainData] = useState();

    useEffect(() => {
        isMounted.current = true;
        const token = localStorage.getItem("Token");
        setToken(token);
        getAllProduct(store);

        return () => {
            isMounted.current = false;
        };
    }, [store]);


    const getAllProduct = useCallback(async (store) => {
        try {
            const res = await api.getAllProduct(store);
            if (isMounted.current) {
                const allvalues = _.map(res?.data?.products, (row) => ({
                    id: row.id,
                    value: "Normal",
                }));
                setcosttype(allvalues);
                setProductData(res?.data?.products);
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    }, []);
    const FIND_PRODUCT_ID = productData?.find((row) =>
        row?.name?.toLowerCase()?.includes("biotickaire")
    )?.id;
    const FIND_PRODUCT_ID2 = productData?.find((row) =>
        row?.name?.toLowerCase()?.includes("silverkaire")
    )?.id;




    const settings2 = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1500,
        autoplaySpeed: 5000,
        arrows: false,
        autoplay: true,
        afterChange: (index) => setCurrentSlide(index),

        responsive: [
            {
                breakpoint: 1020,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    arrows: false,
                    autoplay: true,
                    speed: 1500,
                    autoplaySpeed: 5000,
                    afterChange: (index) => setCurrentSlide(index),
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    arrows: false,
                    autoplay: true,
                    speed: 1500,
                    autoplaySpeed: 5000,
                    afterChange: (index) => setCurrentSlide(index),
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    arrows: false,
                    autoplay: true,
                    speed: 1500,
                    autoplaySpeed: 5000,
                    afterChange: (index) => setCurrentSlide(index),
                }
            },

        ],
    };


    const handleAddCart = (productId, quantity, isAutoShip = false, variantId = null) => {
        if (!productId) return;

        const formData = {
            product_id: productId,
            variant_id: variantId,
            token: Logintoken,
            quantity: quantity,
            is_autoship: isAutoShip
        };

        api.addToCart(formData).then((res) => {
            if (res?.data?.code === 1) {
                setAddNotify('Added To Cart')
                setTimeout(() => {
                    setAddNotify('')
                }, 2000);
                props?.setshowminicart(true)

            }
        })
    }


    const BiotickKaireVideos = [
        {
            urlData: `https://admin.shopkaire.com///media/products/2024/08/05/BioticKaire-min-2.png`,
            thumbnail: 'https://admin.shopkaire.com///media/products/2024/08/05/BioticKaire-min-2.png',
            isImage: true,
        },
        {
            urlData: `https://player.vimeo.com/video/1053933481?autoplay=false&loop=0&autopause=1&controls=true`,
            thumbnail: 'https://i.vimeocdn.com/video/1922605922-8e262966734fde637e0ca45b6e6b94814ab95670c5bedca4e5142585a59690d5-d?mw=300&mh=536',
            title: "Maritime Prime"
        },
        {
            urlData: "https://player.vimeo.com/video/1010759116?autoplay=false&loop=0&autopause=1&controls=true",
            thumbnail: 'https://i.vimeocdn.com/video/1928181056-b629ce9815bb516a499292326d10b82dd809846777d92c15c1a6e8b3cabf658e-d?mw=300&mh=536',
            title: "BioticKaire+"
        },
        {
            urlData: "https://player.vimeo.com/video/1055079623?autoplay=false&loop=0&autopause=1&controls=true",
            thumbnail: 'https://i.vimeocdn.com/video/1922540731-c2e48aabf635b4dda5fc2ea611e4b6a6c45d913828fa491293312c7e1e4f4439-d?mw=300&mh=536',
            title: "SilverKaire"
        },

    ]

    const BiotickKaireVideo2 = [
        {
            urlData: `https://admin.shopkaire.com///media/products/2024/08/05/BioticKaire-min-2.png`,
            thumbnail: 'https://admin.shopkaire.com///media/products/2024/08/05/BioticKaire-min-2.png',
            isImage: true,
        },
        {

            urlData: `https://player.vimeo.com/video/1005957632?autoplay=false&loop=0&autopause=1&controls=true`,
            thumbnail: 'https://i.vimeocdn.com/video/1922605922-8e262966734fde637e0ca45b6e6b94814ab95670c5bedca4e5142585a59690d5-d?mw=300&mh=536',
        },
        {
            urlData: "https://player.vimeo.com/video/1010759116?autoplay=false&loop=0&autopause=1&controls=true",
            thumbnail: 'https://i.vimeocdn.com/video/1928181056-b629ce9815bb516a499292326d10b82dd809846777d92c15c1a6e8b3cabf658e-d?mw=300&mh=536',
        },
        {
            urlData: "https://player.vimeo.com/video/1005901656?autoplay=false&loop=0&autopause=1&controls=true",
            thumbnail: 'https://i.vimeocdn.com/video/1922540731-c2e48aabf635b4dda5fc2ea611e4b6a6c45d913828fa491293312c7e1e4f4439-d?mw=300&mh=536',
        },

    ]
    const Prime180kaireVideos = [
        {
            urlData: "https://player.vimeo.com/video/1053933481?autoplay=false&loop=0&autopause=1&controls=true",
            thumbnail: '/images/man-prime-pic.jpg',
        },

    ]

    useEffect(() => {
        const displayPopupKey = sessionStorage.getItem('PopUpDispaly');
        if (!displayPopupKey) {
            if (window.requestIdleCallback) {
                requestIdleCallback(() => {
                    // setOpenPopup(true);
                    setTimeout(() => {
                        setOpenPopup(true);
                    }, 10000);
                });
            } else {
                setTimeout(() => {
                    setOpenPopup(true);
                }, 10000);
            }
            sessionStorage.setItem('PopUpDispaly', 'true');
        }
        if (REFERRAL_CODE) {
            sessionStorage.setItem('referral-code', true);
            const refCode = sessionStorage.getItem('referral-code');
            setStoreReferral(refCode);
        };

        return () => {
        };
    }, [REFERRAL_CODE, router]);


    useEffect(() => {
        if (REFERRAL_CODE === null) {
            const referral_user = localStorage.getItem('referral_code');
            setStoreReferral(referral_user);
            const dataref = JSON.parse(localStorage.getItem('correctRefferal'));
            setDomainData(dataref?.data?.email);
        }

        if (REFERRAL_CODE?.length > 0 || storeReferral) {
            setOpenClaimGift(true);
        };

    }, [router])

    // const homepageBanners = bannerData?.filter(promotion => promotion?.promotion_type === "Homepage_Banner")?.flatMap(promotion => {
    //     if (Array.isArray(promotion?.banners)) {
    //         return promotion?.banners.filter(banner => banner?.is_active);
    //     }
    //     return [];
    // }) ?? [];

    const homepageBanners = Array.isArray(bannerData)
        ? bannerData?.filter(promotion => promotion?.promotion_type === "Homepage_Banner")
            .reduce((acc, promotion) => {
                if (Array.isArray(promotion?.banners)) {
                    const activeBanners = promotion?.banners?.filter(banner => banner?.is_active);
                    return acc.concat(activeBanners);
                }
                return acc;
            }, [])
        : [];

    const sortedBanners = homepageBanners?.sort((a, b) => a.ordering - b.ordering);
    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setShowProven(true);
                observer.disconnect();
            }
        });

        setTimeout(() => {
            if (provenRef.current) {
                observer.observe(provenRef.current);
            }
        }, 500);

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <Head>
                {sortedBanners?.[0]?.banner_image && (
                    <link rel="preload" as="image" href={`${process.env.API_URL}${sortedBanners[0].banner_image}`} />
                )}
            </Head>

            <HomeComponent promotionBannerMobile={homePageData?.content[0]?.discount_banner_image_mobile}>
                <div className="home-page" >
                    <div className='welcome-section'>
                        <div className="welcome_banner">
                            <div className='container'>
                                <div className='main-banner-section flex'>
                                    <div className='left-side-image'>
                                        <Slider {...settings2}>
                                            {sortedBanners?.map((banner, index) => (
                                                <div key={index}>
                                                    <Link href={banner?.link} passHref>
                                                        <img
                                                            src={process.env.API_URL + banner.banner_image}
                                                            alt={banner.text_heading}
                                                            width={1600}
                                                            height={600}
                                                            style={{ backgroundColor: banner.background_color }}
                                                            loading={index === 0 ? "eager" : "lazy"}
                                                            decoding="async"
                                                        />
                                                    </Link>
                                                </div>
                                            ))}
                                        </Slider>

                                    </div>

                                    <div className='right-side-text'>
                                        <div className='inside-right-sec'>
                                            <div className='banner-homepage'>
                                                <div style={{
                                                    backgroundColor: sortedBanners?.[currentSlide]?.background_color, color: sortedBanners?.[currentSlide]?.text_color,
                                                }}
                                                >
                                                    {sortedBanners?.[currentSlide]?.text_content &&
                                                        parse(sortedBanners?.[currentSlide]?.text_content)}
                                                </div>
                                            </div>
                                            <div className="btn-link">
                                                <Link className="nav-link" exact href={`/${store}/allProduct`}>
                                                    <a className="link">Shop Now</a>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='biotickakire-video-sec'>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="biotickakire-video-wrap">
                                        <h2>POTENT, NATURAL NOURISHMENT FOR FEELING YOUR BEST.</h2>
                                        <div className="biotickakire-video-innerwrap">
                                            {BiotickKaireVideos?.slice(1)?.map((video, index) => {
                                                return (
                                                    <>
                                                        <div key={index} className='biotickakire-video'>
                                                            <div className="biotickakire-video-maon-section" key={index}>
                                                                <iframe src={video?.urlData} width="100%" height="auto" frameborder="0" allow="autoplay; fullscreen;" allowfullscreen loading="lazy"></iframe>
                                                            </div>
                                                            <p>{video?.title}</p>
                                                        </div>
                                                    </>

                                                )
                                            })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {showProven &&
                        <HomePageProduct productData={productData} costtype={costtype} setcosttype={setcosttype} quantityCheck={quantityCheck} setQuantityCheck={setQuantityCheck}
                            handleAddCart={handleAddCart}
                            AddCardButtonText={AddCardButtonText} addNotify={addNotify} minCartAutoshipCheck={minCartAutoshipCheck}
                            smartShipCheck={smartShipCheck}
                        />
                    }
                    <div className="welcome-section Prime-sec">
                        <div className="welcome_banner welcome_banner_2 ">
                            <div className='container'>
                                <div className='main-banner-section flex'>
                                    <div className='left-side-image'>
                                        <img src='/images/maritime.jpg' loading="lazy" />
                                    </div>
                                    <div className='right-side-text'>
                                        <div className='inside-right-sec'>
                                            <h2 className='heading-font home-heading-common'>Maritime Prime™
                                                Pycnogenol<sup>®</sup> French Maritime Pine Bark Extract</h2>
                                            <p>Pycnogenol<sup>®</sup> is an amazing gift from nature, but not all Pycnogenol<sup>®</sup> products are created equally. Maritime Prime Pycnogenol® does not contain inexpensive fillers to bolster profitability.  Our proprietary blend incorporates only the finest plant-based ingredients and enzymes, ensuring peak effectiveness and absorption – making it a truly unique and incomparable product.
                                            </p>
                                            {Prime180kaireVideos?.slice(0)?.map((video, index) => {
                                                return (
                                                    <div className="prime-video-data mobile-view" key={index}>
                                                        <iframe src={video?.urlData} width="100%" height="auto" frameborder="0" allow="autoplay; fullscreen;"
                                                            allowfullscreen loading="lazy" ></iframe>
                                                    </div>
                                                )
                                            })
                                            }
                                            <div className='inner-img-div'>
                                                <img src='/images/product-home.webp' loading="lazy" />
                                            </div>
                                            <div className="btn-link">
                                                <button className="add_cart main_btn_common" onClick={() => { setInnerLoader(true), router?.push("/us/product/Super_Prime_120/8/") }}>Shop now</button>
                                            </div>
                                        </div>
                                        {Prime180kaireVideos?.slice(0)?.map((video, index) => {
                                            return (
                                                <div className="prime-video-data desktop-view" key={index}>
                                                    <iframe src={video?.urlData} width="100%" height="auto" frameborder="0" allow="autoplay; fullscreen;"
                                                        allowfullscreen loading="lazy" ></iframe>
                                                </div>

                                            )
                                        })
                                        }
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='proven-benefits section' ref={provenRef}>
                        <div className='container'>
                            {showProven && <ProvenComponent />}
                        </div>
                    </div>
                    {showProven &&
                        <HomePageBelowSection FIND_PRODUCT_ID={FIND_PRODUCT_ID} FIND_PRODUCT_ID2={FIND_PRODUCT_ID2} handleAddCart={handleAddCart}
                            BiotickKaireVideo2={BiotickKaireVideo2} BiotickKaireVideos={BiotickKaireVideos}
                        />
                    }

                </div>

            </HomeComponent>
            {(!Logintoken && !storeReferral && productData?.length > 0) ? (
                <MailingComponent
                    open={openPopup}
                    setOpenPopup={setOpenPopup}
                    setInnerLoader={setInnerLoader}
                    innerLoader={innerLoader}
                    REFERRAL_CODE={REFERRAL_CODE}
                />
            ) : (!Logintoken && storeReferral && productData?.length > 0) ? (
                <ClaimGiftPopup
                    openClaimGift={openClaimGift}
                    setOpenClaimGift={setOpenClaimGift}
                    subDomain={subDomain}
                    setInnerLoader={setInnerLoader}
                    innerLoader={innerLoader}
                    REFERRAL_CODE={REFERRAL_CODE}
                    USER_DATA={USER_DATA}
                    domainData={domainData}
                    storeReferral={storeReferral}
                />
            ) : null
            }

        </>
    )
}
export default Home;


